// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FQ_r","tabsBox":"styles_tabsBox__iBehP","createButton":"styles_createButton__RWQa5"};